/** Excel column / worksheet / file names for Sales & Catering exports. */

export enum SnCExcelHeader {
  Address1 = "ADDRESS1",
  Address2 = "ADDRESS2",
  Address3 = "ADDRESS3",
  AutoReceipt = "AutoReceipt",
  BuildingCode = "BUILDING_CODE",
  Category = "CATEGORY",
  CategoryGroupName = "CategoryGroupName",
  City = "CITY",
  Code = "code",
  ColorCode = "colorCode",
  Comments = "comments",
  CommentsUpper = "COMMENTS",
  ContactType = "CONTACT_TYPE",
  Cost = "COST",
  AvgAudioVisual = "AVG_AUDIO_VISUAL",
  AvgBeverage = "AVG_BEVERAGE",
  AvgFood = "AVG_FOOD",
  AvgMiscellaneous = "AVG_MISCELLANEOUS",
  CountByCovers = "COUNT_BY_COVERS",
  CountCovers = "COUNT_COVERS",
  Country = "COUNTRY",
  DispLocation = "dispLocation",
  EligibleForCostOrCostPlus = "EligibleForCostOrCostPlus",
  EligibleForDiscount = "EligibleForDiscount",
  EligibleForInHouseServiceChargeCalculation = "EligibleForInHouseServiceChargeCalculation",
  EmailAddress = "EMAIL_ADDRESS",
  EmailType = "EMAIL_TYPE",
  EndDate = "endDate",
  EndTime = "END_TIME",
  ExcelGroupId = "EXCEL_GROUP_ID",
  ExcelGroupNumber = "EXCEL_GROUP_NUMBER",
  FoodTypeCodes = "FOOD_TYPE_CODES",
  FunctionTypeCode = "FUNCTION_TYPE_CODE",
  FunctionTypeName = "FUNCTION_TYPE_NAME",
  Gratuity = "GRATUITY",
  HidePrice = "HIDE_PRICE",
  HideQuantity = "HIDE_QUANTITY",
  Id = "id",
  IdPascal = "Id",
  IncldOnReport = "INCLD_ON_REPORT",
  IsActive = "isActive",
  IsActivePascal = "IsActive",
  IsActiveUpper = "ISACTIVE",
  ItemCode = "ITEM_CODE",
  ItemNumber = "ITEM_NUMBER",
  LineType = "lineType",
  Location = "LOCATION",
  ManagerFirstName = "MANAGER_FIRSTNAME",
  ManagerGroupNumber = "MANAGER_GROUP_NUMBER",
  ManagerLastName = "MANAGER_LASTNAME",
  ManagerType = "MANAGER_TYPE",
  MappingCode = "MAPPING_CODE",
  MenuItemCode = "MENU_ITEM_CODE",
  MenuItemName = "MENU_ITEM_NAME",
  Name = "name",
  NamePascal = "Name",
  NameUpper = "NAME",
  OutletName = "OutletName",
  PhoneNumber = "PHONE_NUMBER",
  PostalCode = "POSTAL_CODE",
  Presentation = "PRESENTATION",
  Price = "PRICE",
  ProfitCenter = "ProfitCenter",
  PropertyCode = "PROPERTY_CODE",
  Quantity = "QUANTITY",
  RetailItemNumber = "RETAIL_ITEM_NUMBER",
  ServiceCharge = "SERVICE_CHARGE",
  SetupCode = "SETUP_CODE",
  StartDate = "startDate",
  StartTime = "START_TIME",
  State = "STATE",
  TerminalId = "TerminalId",
  TrackQuantity = "TRACK_QUANTITY",
  UnitCost = "UNIT_COST",
  UnitOfMeasureCode = "UNIT_OF_MEASURECODE",
  UnitOfMeasureCodeUnderscore = "UNIT_OF_MEASURE_CODE",
  UnitPrice = "UNIT_PRICE",
  VendorName = "VENDOR_NAME",
}

export enum SnCExcelSourceField {
  Active = "Active",
  AutoPrintsReceipts = "Auto Prints Receipts",
  ExcelGroupNumber = "EXCEL_GROUP_NUMBER",
  ArrivalTypeCode = "Arrival Type Code",
  ArrivalTypeName = "Arrival Type Name",
  AudioVisualCode = "Audio Visual Code",
  AudioVisualName = "Audio Visual Name",
  BeverageCode = "Beverage Code",
  BeverageName = "Beverage Name",
  Building = "Building",
  FunctionRoomCode = "Function Room Code",
  FunctionRoomName = "Function Room Name",
  RevenueType = "Revenue Type",
  RoomFeatures = "Room Features",
  CallTypeCode = "Call Type Code",
  CallTypeName = "Call Type Name",
  CancelCode = "Cancel Code",
  CancelCodeName = "Cancel Code Name",
  CancellationPolicy = "Cancellation Policy",
  CancellationPolicyCode = "Cancellation Policy Code",
  CancellationPolicyName = "Cancellation Policy Name",
  CategoryGroup = "Category Group",
  CategoryName = "Category Name",
  ContactTypeCode = "Contact Type Code",
  ContactTypeName = "Contact Type Name",
  DenialCode = "Denial Code",
  DenialCodeName = "Denial Code Name",
  DisplayLine = "Display Line",
  DisplayLocation = "Display Location",
  DistributionListCode = "Distribution List Code",
  DistributionListName = "Distribution List Name",
  EligibleForCostOrCostPlus = "Eligible for Cost Plus",
  EligibleForDiscount = "Eligible for Discount",
  EligibleForInHouseServiceChargeCalculation = "Eligible for In House Service Charge",
  FeatureCode = "Feature Code",
  FeatureName = "Feature Name",
  FeeTypeCode = "Fee Type Code",
  FeeTypeName = "Fee Type Name",
  FoodType = "Food Type",
  FoodTypes = "Food Types",
  FoodTypeCode = "Food Type Code",
  FoodTypeName = "Food Type Name",
  FunctionTypeCode = "Function Type Code",
  FunctionTypeCodeName = "Function Type Code Name",
  HolidayHotDateCode = "Holiday/Hot Date Code",
  HolidayHotDateName = "Holiday/Hot Date Name",
  StartDateField = "Start Date",
  EndDateField = "End Date",
  Id = "id",
  IncidentalCode = "Incidental Code",
  IncidentalName = "Incidental Name",
  IsActiveManager = "ISACTIVE",
  ItemCode = "Item Code",
  ManagerFirstName = "MANAGER_FIRSTNAME",
  ManagerGroupNumber = "MANAGER_GROUP_NUMBER",
  ManagerLastName = "MANAGER_LASTNAME",
  ManagerType = "MANAGER_TYPE",
  MappingCode = "MAPPING_CODE",
  MenuItemCode = "Menu Item Code",
  MenuItemName = "Menu Item Name",
  MiscellaneousCode = "Miscellaneous Code",
  MiscellaneousName = "Miscellaneous Name",
  NextStepCode = "Next Step Code",
  NextStepName = "Next Step Name",
  OutletName = "Outlet Name",
  PotentialCode = "Potential Code",
  PotentialCodeName = "Potential Code Name",
  ReservedByCode = "Reserved By Code",
  ReservedByName = "Reserved By Name",
  RevenueItem = "Revenue Item",
  RoomAndTaxCode = "Room and Tax Code",
  RoomAndTaxName = "Room and Tax Name",
  SetupCode = "Setup Code",
  SetupName = "Setup Name",
  SetupStyleCode = "Setup Style Code",
  SetupStyleName = "Setup Style Name",
  UnitOfMeasure = "Unit of Measure",
  UnitsOfMeasure = "Units of Measure",
  UnitOfMeasureCode = "Unit of Measure Code",
  UnitOfMeasureName = "Unit of Measure Name",
}

export enum SnCExcelSheetName {
  ArrivalType = "Arrival Type",
  AudioVisualItem = "AudioVisualItem",
  AudioVisualItemMeasurement = "AudioVisualItemMeasurement",
  AudioVisualItemRevenuetype = "AudioVisualItemRevenuetype",
  BeverageItem = "BeverageItem",
  BeverageItemMeasurement = "BeverageItemMeasurement",
  BeverageItemRevenuetype = "BeverageItemRevenuetype",
  CancellationCodes = "Cancellation Codes",
  CancellationPolicy = "Cancellation Policy",
  Category = "Category",
  CategoryGroup = "CategoryGroup",
  ContactType = "Contact Type",
  DenialCode = "Denial Code",
  DistributionListCode = "Distribution List Code",
  FoodType = "Food Type",
  FunctionItemMeasurement = "FunctionItemMeasurement",
  FunctionItemRevenuetype = "FunctionItemRevenuetype",
  FunctionRoom = "Function Room",
  FunctionRoomFeature = "Function Room Feature",
  FunctionRoomFee = "Function Room Fee",
  FunctionRoomSetup = "Function Room Setup",
  FunctionType = "Function Type",
  Holiday = "Holiday",
  Incidentals = "Incidentals",
  Managers = "Managers",
  MenuItem = "Menu Item",
  MenuItemMeasurement = "Menu_Item_Measurement",
  MenuItemRevenueType = "Menu_Item_Revenue_Type",
  MiscellaneousItem = "MiscellaneousItem",
  MiscellaneousItemMeasurement = "MiscellaneousItemMeasurement",
  MiscellaneousItemRevenuetype = "MiscellaneousItemRevenuetype",
  Outlet = "Outlet",
  PotentialCode = "Potential Code",
  ReservedByCode = "Reserved By Code",
  /** Retail Items Setup → Visual One RetailItem worksheet. */
  RetailItem = "RetailItem",
  RoomAndTax = "RoomAndTax",
  SalesCallStep = "Sales Call Step",
  SalesCallType = "Sales Call Type",
  SetupItem = "SetupItem",
  UnitOfMeasure = "Unit Of Measure",
}

export enum SnCExcelFileName {
  ArrivalTypes = "Arrival Type",
  AudioVisualItems = "Audio visual items",
  BeverageItems = "Beverage items",
  CancelCodes = "Cancellation Codes",
  CancellationPolicy = "Cancellation Policy",
  Category = "Category",
  CategoryGroup = "CategoryGroup",
  ContactTypes = "Contact Type",
  DenialCodes = "Denial Code",
  DistributionListCodes = "Distribution List Code",
  FoodTypes = "Food Type",
  FunctionRoom = "Function Room",
  FunctionRoomFeature = "Function Room Feature",
  FunctionRoomFeeType = "Function Room Fee",
  FunctionRoomSetup = "Function Room Setup",
  FunctionType = "Function Type",
  HolidayAndHotDates = "Holiday",
  Incidentals = "Incidentals",
  Managers = "Managers",
  MenuItems = "Menu items",
  MiscellaneousItem = "Miscelaneous item",
  Outlet = "Outlet",
  PotentialCodes = "Potential Code",
  ReservedByCodes = "Reserved By Code",
  RetailItems = "RetailItem",
  RoomAndTax = "RoomAndTax",
  SalesCallCallTypes = "Sales call call types",
  SalesCallsNextSteps = "sales calls next steps",
  SetupItems = "setup items",
  UnitsOfMeasure = "Unit Of Measure",
}
